import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import style from './style.scss'; //NOSONAR

const CustomSelect = (props) => {

    let selected = props.value || null;
    
    const onChange = (selectedOption) => {
        selected = selectedOption;
        if(props.onChange){
            props.onChange(selectedOption);
        }
    }

    const placeholder = props.placeholder || 'Select...';
    const options = props.options || [];
    const customStyles = {
        indicatorSeparator: () => false,
        option: () => ({backgroundColor: null}),
    };

    const DropdownIndicator = (properties) => {
        return (
            <components.DropdownIndicator {...properties}>
                <i></i>
            </components.DropdownIndicator>
        );
    };
    return(
        <div className="custom-select">
            <Select options={options} value={selected} components={{ DropdownIndicator }} className={'select' + (props.disabled ? ' disabled ' : '')} styles={customStyles} classNamePrefix="select" onChange={onChange} placeholder={placeholder} />
        </div>
    )
}

CustomSelect.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    options: PropTypes.array,
    disabled: PropTypes.bool
};

export default CustomSelect;
